import React from "react";
import Image from "next/image";

const BridgeEligibilty: React.FC = () => {
  return (
    <>
      <div
        id="CPA Eligibility Requirements"
        className="bg-white w-full md:py-[50px] py-8 relative md:bg-bottom bg-center md:bg-[url(/home/footer_bg.png)] bg-repeat bg-cover bg-[length:100% 100%] relative"
      >
        <div className="lg:container mx-auto h-full 2xl:px-0 xl:px-12 lg:px-6 px_5 relative lg:block hidden">
          <div>
            <div className="text-center">
              <h2 className="text-2xl lg:text-[36px] md:text-[60px] mb-3 lg:leading-[1.3] md:leading-[3rem] leading-[1.8rem] text-[#000] font-semibold text-center inline-block mx-auto px-[4px] md:mb-[30px]">
                <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                  CPA Eligibility Requirements
                </span>
              </h2>
            </div>
            <div className="flex flex-row gap-3 justify-center md:mt-6">
              <div className="investment px-12 py-2 rounded-md">
                <div className="md:leading-[1.2]">
                  <p className="text-[30.786px] text-[#FFF]">CPA exam</p>
                  <p className="text-[30.786px] text-[#FFF] font-semibold">
                    120 Credits
                  </p>
                </div>
              </div>
              <div className="investment px-12 py-2 rounded-md">
                <div className="md:leading-[1.2]">
                  <p className="text-[30.786px] text-[#FFF]">CPA license</p>
                  <p className="text-[30.786px] text-[#FFF] font-semibold">
                    150 Credits
                  </p>
                </div>
              </div>
              <div className="border-[1.333px] border-[#FFA548] bg-[#FFFFFF] rounded-lg">
                <div className="px-4 py-2 rounded-md md:leading-[1.2] items-start shadow-lg shadow-gray-400">
                  <p className="text-black font-medium text-[20px] mr-6">
                    <span className="font-bold">
                      {" "}
                      Understanding U.S. semester hour credits:
                    </span>
                    <br /> Every year of university education is equivalent to
                    <br />
                    30 U.S. semester hour credits
                  </p>
                </div>
              </div>
            </div>
            <div className="flex justify-center ">
              <div className="">
                <p className="text-20px text-[#000] font-semibold text-center bg-[#FFA548] py-2 mt-12 px-4">
                  The CPA exam eligibility requirement is a 4-year Bachelors'
                  Degree (120 U.S. semester hour credits)
                </p>
              </div>
            </div>
            <div className="flex justify-center py-4 w-auto">
              <p className="text-[36.79px] font-semibold">BUT</p>
            </div>
            <div className="flex flex-row justify-center">
              <div className="bridge flex py-2 px-14 gap-10">
                <div className="justify-start">
                  <Image
                    src="/cpa/bridge-course/iconTri.png"
                    alt="icon"
                    className="pt-2"
                    width={90.001}
                    height={55.277}
                    priority
                  />
                </div>
                <p className="text-white text-[25px]">
                  Under the Pre-Education Eligibility option, you can now appear
                  for the <br /> CPA exam with a 3-year B.Com/BBA (120 U.S.
                  semester hour credits)
                  <br />
                  <span className="text-[18px] md:leading-[2]">
                    *If you submit a proof of enrolment into Miles' Approved
                    Bridge Program.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BridgeEligibilty;
